import React from 'react';
import { Link } from 'react-router-dom';

export default function YourBooksSectionHeader({ headerText, showInGrid }) {
	return (
		<React.Fragment>
			{showInGrid ? (
				<React.Fragment>
					<div className="column">
						<Link className="clickable" to={`/yourbooks`}>
							<div className="column yourbooks-back-icon icon-books acc-font" />
						</Link>
					</div>
					<div className="column-spaced">:</div>
					<div className="column-spaced">{headerText}</div>
					<div className="clear" />
				</React.Fragment>
			) : (
				<span>{headerText}</span>
			)}
		</React.Fragment>
	);
}
